module.exports = "/_next/static/images/chavaty_takeout_top-f96445b5c445d970ce7a8f341c23379e.jpg";